import { LOAD_STATE } from '@/shared/types'
import type { HotCollectiveRankResponse } from '@/server/types'
import { getHotCollectiveRankApi } from '@/server'

export function logicHotCollectiveRank() {
  const state = ref(LOAD_STATE.INIT)
  const data = ref<HotCollectiveRankResponse[]>([])

  async function getRankData() {
    const res = await useLoadState({
      state,
      key: `集体投诉征集`,
      onlyClient: true,
      fn: () => getHotCollectiveRankApi(),
    })

    if (res && res.data)
      data.value = res.data
  }

  return {
    state,
    data,
    getRankData,
  }
}
